import Icon from "@ant-design/icons";

const SVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22.008"
    height="22.002"
    viewBox="0 0 22.008 22.002"
  >
    <g id="pie-chart" transform="translate(-0.992 -1)">
      <path
        id="Path_1072"
        data-name="Path 1072"
        d="M21.21,15.89A10,10,0,1,1,8,2.83"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        id="Path_1073"
        data-name="Path 1073"
        d="M22,12A10,10,0,0,0,12,2V12Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </g>
  </svg>
);

const AntdIcon = (props) => <Icon component={SVG} {...props} />;

export default AntdIcon;
